// src/api/client.js
import axios from 'axios';
import { getAuthCode, getUserId } from './authStorage';

const client = axios.create({
  baseURL: 'https://writemybio.us/bio/api/code/admin',
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use(cfg => {
  const authCode = getAuthCode();
  const userId   = getUserId();
  if (authCode && userId) {
    cfg.data = {
      ...(cfg.data || {}),
      user_id:   userId,
      auth_code: authCode
    };
  }
  return cfg;
});

export default client;
